import styled from "styled-components";
import { motion } from "framer-motion";

//Interface
import { PaymentStatus } from "./interfaces";

//Assets
import colors from "../../assets/css/colors";

const bgStatus = {
    paid: colors.ricepaper,
    pending: colors.ricepaper
}

const borderStatus = {
    paid: colors.secondary,
    pending: colors.secondary,
    failed: colors.red
}

const backgroundColorDefiner = (status: string) => {
    return bgStatus[status as keyof typeof bgStatus] ?? colors.anpacsBlood
}

const borderLeftColorDefiner = (status: string) => {
    return borderStatus[status as keyof typeof borderStatus] ?? colors.gray
}

export const Container = styled(motion.div)`
    margin-bottom: 19px;
`;

export const PaymentItemContainer = styled(motion.div)`
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    height: 39px;

    background-color: ${(p: PaymentStatus) => backgroundColorDefiner(p.status)};

    border-radius: 8px;
    border-left: 4px solid ${(p: PaymentStatus) => borderLeftColorDefiner(p.status)} ;

    padding: 0px 19px;
`;

export const PaymentOrder = styled.h2`
    margin: 0;

    font-family: muli, sans-serif;
    font-size: 14px;
    font-weight: bold;
    margin-right: 8px;
`;

export const PaymentOrderDate = styled.h2`
    margin: 0;

    font-family: muli, sans-serif;
    font-size: 12px;
    font-weight: lighter;
`;

export const DetailsPaymentContainer = styled(motion.div)`
    background-color: ${(p: PaymentStatus) => backgroundColorDefiner(p.status)};

    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;

    padding: 2px 12px 12px 21px;

    margin-top: -2px;
`;

export const StatusContainer = styled.div`
    display: flex;
    justify-content: center;

    margin-top: -1px;
    margin-bottom: 24px;
`;

export const Status = styled.div`
    width: 94px;
    height: 16px;

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: ${(p: PaymentStatus) => borderLeftColorDefiner(p.status)};

    font-size: 11px;
    font-family: muli, sans-serif;
    color: ${colors.white};
`;

export const PlanDescriptionAndButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const PaymentTitleText = styled.p`
    font-family: muli, sans-serif;
    font-size: 10px;
    
    color: black;

    margin: 0;
    margin-bottom: 3px;
`;

export const PlanDescritionText = styled.p`
    font-family: muli, sans-serif;
    font-size: 11px;
    
    color: ${colors.grayDark};

    margin: 0;
`;

export const Button = styled.button`
    width: 75px;
    height: 20px;

    border: 1px solid ${colors.primary};
    border-radius: 4px;
    
    background-color: ${colors.white};
    color: ${colors.primary};

    font-family: muli, sans-serif;
    font-size: 9px;

    outline: none;
`;